<template>
  <div class="inputgrouplocation">
    <section>
      <div class="inputgrouplocation-field">
        <AutoComplete
          id="onLocation"
          :value="onLocation"
          :disabled="disabled"
          :items="locationList"
          name="onLocation"
          validation="required"
          labelText="*上車地址"
          @input="handleLocationKeyword($event, 'onLocation')"
          @selectDropdownItem="selectOnLocation"
          class="inputgrouplocation-field-location widerlabel"
        />
        <div
          class="inputgrouplocation-field-location-button-group"
          v-if="!disabled"
        >
          <b-button
            :disabled="onLocationKeyword.length < 6"
            variant="outline-secondary"
            @click="searchGoogleLocation('onLocation')"
            >Google 搜尋</b-button
          >
          <b-button
            :disabled="!Boolean(onLocationKeyword)"
            variant="outline-secondary"
            @click="searchCustomizeLocation('onLocation')"
            >地標搜尋</b-button
          >
          <b-button
            size="sm"
            variant="outline-secondary"
            :disabled="!orderUserLocation.address"
            @click.prevent="$emit('inputOnLocation', orderUserLocation)"
            >同地址</b-button
          >
          <b-button
            size="sm"
            variant="outline-secondary"
            :disabled="!historyLocation"
            @click.prevent="$emit('inputOnLocation', historyLocation)"
            >歷史點</b-button
          >
        </div>
      </div>

      <div class="inputgrouplocation-field" v-if="!disabled">
        <BaseInput
          :value="onLocationGps[0] ? onLocationGps[0] : ''"
          labelText="上車經度"
          @input="handleOnLat"
          class="inputgrouplocation-field-sub widerlabel"
        />
        <BaseInput
          :value="onLocationGps[1] ? onLocationGps[1] : ''"
          labelText="上車緯度"
          @input="handleOnLong"
          class="inputgrouplocation-field-sub widerlabel"
        />
      </div>

      <div class="inputgrouplocation-field">
        <AutoComplete
          id="offLocation"
          :value="offLocation"
          :disabled="disabled"
          labelText="*下車地址"
          :items="locationList"
          name="offLocation"
          validation="required"
          @input="handleLocationKeyword($event, 'offLocation')"
          @selectDropdownItem="selectOffLocation"
          @searchGoogleLocation="searchGoogleLocation('offLocation')"
          class="inputgrouplocation-field-location widerlabel"
        >
        </AutoComplete>
        <div
          class="inputgrouplocation-field-location-button-group"
          v-if="!disabled"
        >
          <b-button
            :disabled="offLocationKeyword.length < 6"
            variant="outline-secondary"
            @click="searchGoogleLocation('offLocation')"
            >Google 搜尋</b-button
          >
          <b-button
            :disabled="!Boolean(offLocationKeyword)"
            variant="outline-secondary"
            @click="searchCustomizeLocation('offLocation')"
            >地標搜尋</b-button
          >
          <b-button
            size="sm"
            variant="outline-secondary"
            :disabled="!orderUserLocation.address"
            @click.prevent="$emit('inputOffLocation', orderUserLocation)"
            >同地址</b-button
          >
          <b-button
            size="sm"
            variant="outline-secondary"
            :disabled="!historyLocation"
            @click.prevent="$emit('inputOffLocation', historyLocation)"
            >歷史點</b-button
          >
        </div>
      </div>

      <div class="inputgrouplocation-field" v-if="!disabled">
        <BaseInput
          :value="offLocationGps[0] ? offLocationGps[0] : ''"
          labelText="下車經度"
          @input="handleOffLat"
          class="inputgrouplocation-field-sub widerlabel"
        />
        <BaseInput
          :value="offLocationGps[1] ? offLocationGps[1] : ''"
          labelText="下車緯度"
          @input="handleOffLang"
          class="inputgrouplocation-field-sub widerlabel"
        />
      </div>

      <slot name="addition-content"></slot>
    </section>

    <section
      class="inputgrouplocation-ride-coordinate"
      v-if="!disabled && userHistoryAddress.length"
    >
      <b-table
        hover
        selectable
        select-mode="single"
        :fields="userHistoryAddressFields"
        :items="userHistoryAddress"
        @row-selected="historyLocationSelect"
      ></b-table>
    </section>
  </div>
</template>

<script>
import BaseInput from '@/components/base/BaseInput';
import AutoComplete from '@/components/commen/AutoComplete';

import { mapGetters, mapActions } from 'vuex';
import { Loader } from 'google-maps';

export default {
  name: 'InputGroupLocation',
  components: {
    BaseInput,
    AutoComplete
  },
  props: {
    onLocation: {
      type: String,
      required: true
    },
    orderUserLocation: {
      type: Object,
      default: () => {}
    },
    onLocationGps: {
      type: Array,
      default: () => []
    },
    offLocation: {
      type: String,
      required: true
    },
    offLocationGps: {
      type: Array,
      required: () => []
    },
    userHistoryAddressFields: {
      type: Array,
      required: true
    },
    userHistoryAddress: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      historyLocation: null,
      cities: [
        { city: '台南市', value: '67000' },
        { city: '高雄市', value: '64000' },
        { city: '臺北市', value: '63000' },
        { city: '台北市', value: '63000' },
        { city: '臺中市', value: '66000' },
        { city: '台中市', value: '66000' },
        { city: '桃園市', value: '68000' },
        { city: '新北市', value: '65000' },
        { city: '臺東縣', value: '10014' },
        { city: '台東縣', value: '10014' },
        { city: '彰化縣', value: '10007' },
        { city: '嘉義縣', value: '10010' },
        { city: '嘉義市', value: '10020' },
        { city: '新竹縣', value: '10004' },
        { city: '新竹市', value: '10018' },
        { city: '雲林縣', value: '10009' },
        { city: '基隆市', value: '10017' },
        { city: '苗栗縣', value: '10005' },
        { city: '屏東縣', value: '10013' },
        { city: '南投縣', value: '10008' },
        { city: '花蓮縣', value: '64000' },
        { city: '宜蘭縣', value: '10002' },
        { city: '澎湖縣', value: '10016' },
        { city: '金門縣', value: '09020' }
      ],
      onLocationKeyword: '',
      offLocationKeyword: '',
      google: null,
      googlePlaceService: null,
      geocoder: null,
      selectdGoogleLocation: null
    };
  },
  methods: {
    ...mapActions({
      fetchLocationList: 'longTerm/fetchLocationList',
      fetchCustomizeLocation: 'longTerm/fetchCustomizeLocation'
    }),
    historyLocationSelect(row) {
      if (!row.length) {
        this.historyLocation = null;
      }
      const location = row;
      this.historyLocation = location[0];
    },
    async handleLocationKeyword(keyword, type) {
      if (type === 'onLocation') {
        this.$emit('inputOnLocation', {
          address: keyword,
          longitude: null,
          latitude: null
        });
        this.onLocationKeyword = keyword;
      }
      if (type === 'offLocation') {
        this.$emit('inputOffLocation', {
          address: keyword,
          longitude: null,
          latitude: null
        });
        this.offLocationKeyword = keyword;
      }

      if (keyword.length > 5) {
        await this.fetchLocationList(keyword);
      }
    },
    async searchGoogleLocation(id) {
      const autoComplete = document.getElementById(id);
      autoComplete.focus();

      const displaySuggestions = (predictions, status) => {
        if (status != this.google.maps.places.PlacesServiceStatus.OK) {
          alert(status);
          return;
        }

        const placesArray = predictions.map(prediction => {
          let address;
          if (prediction.description.indexOf('台灣') === 0) {
            address = prediction.description.replace('台灣', '');
          }
          return {
            address: address,
            id: prediction.place_id,
            gps: {
              coordinates: []
            }
          };
        });

        this.$store.commit('longTerm/locationList', placesArray);
      };

      this.googlePlaceService.getPlacePredictions(
        { input: this[`${id}Keyword`] },
        displaySuggestions
      );
    },
    selectOnLocation(location) {
      // console.log(location);
      this.onLocationKeyword = '';

      if (location.id) {
        this.selectGoogleLocation(
          location.id,
          location.address,
          'inputOnLocation'
        );
      } else if (location.name) {
        this.$emit('inputOnLocation', {
          ...location,
          address: location.address.replace(location.name, '').replace('-', '')
        });
      } else {
        this.$emit('inputOnLocation', location);
      }
    },
    selectOffLocation(location) {
      this.offLocationKeyword = '';

      if (location.id) {
        this.selectGoogleLocation(
          location.id,
          location.address,
          'inputOffLocation'
        );
      } else {
        this.$emit('inputOffLocation', location);
      }
    },
    selectGoogleLocation(id, address, emitType) {
      this.geocoder.geocode(
        {
          placeId: id
        },
        (responses, status) => {
          if (status == 'OK') {
            const longitude = responses[0].geometry.location.lng();
            const latitude = responses[0].geometry.location.lat();

            let removedAddressKey = responses[0].formatted_address
              .trim()
              .replace(/\s/, '')
              .replace(/^\d+/, '');
            if (removedAddressKey.slice(0, 2) === '台灣') {
              removedAddressKey = removedAddressKey.slice(
                2,
                removedAddressKey.length
              );
            }

            let object = {
              longitude,
              latitude
            };

            const isRepeat = address.includes(removedAddressKey);
            if (isRepeat) {
              object.address = address;
            } else {
              object.address = removedAddressKey + '(' + address + ')';
            }
            this.$emit(emitType, object);
          }
        }
      );
    },
    searchCustomizeLocation(id) {
      const autoComplete = document.getElementById(id);
      autoComplete.focus();
      this.fetchCustomizeLocation({
        key: this[`${id}Keyword`],
        isSupportOffice: false
      });
    },
    // parseKeyword(keyword) {
    //   const keyword2Array = keyword.replace(/(市|縣)/g, `$1 `).split(' ');
    //   const intersection = `${keyword2Array[1]} ${keyword2Array[2]}`;
    //   const city = keyword2Array.find(item => item.match(/(縣|市)/)).trim();
    //   const cityCode = this.cities.find(item => item.city === city).value;

    //   return {
    //     key: intersection,
    //     county_number: cityCode
    //   };
    // }
    handleOnLat(value) {
      if (!value) {
        this.$emit('setOnLocationGps', {
          value: [],
          property: 'onLocationGps'
        });
      } else {
        this.$emit('setOnLocationGps', {
          value: [value, this.onLocationGps[1]],
          property: 'onLocationGps'
        });
      }
    },
    handleOnLong(value) {
      if (!value) {
        this.$emit('setOnLocationGps', {
          value: [],
          property: 'onLocationGps'
        });
      } else {
        this.$emit('setOnLocationGps', {
          value: [this.onLocationGps[0], value],
          property: 'onLocationGps'
        });
      }
    },
    handleOffLat(value) {
      if (!value) {
        this.$emit('setOffLocationGps', {
          value: [],
          property: 'offLocationGps'
        });
      } else {
        this.$emit('setOffLocationGps', {
          value: [value, this.offLocationGps[1]],
          property: 'offLocationGps'
        });
      }
    },
    handleOffLang(value) {
      if (!value) {
        this.$emit('setOffLocationGps', {
          value: [],
          property: 'offLocationGps'
        });
      } else {
        this.$emit('setOffLocationGps', {
          value: [this.offLocationGps[0], value],
          property: 'offLocationGps'
        });
      }
    }
  },
  computed: {
    ...mapGetters({
      locationList: 'longTerm/locationList'
    })
  },
  async mounted() {
    const loader = new Loader('AIzaSyARRJy5eO-KF4Ovii349r3PMhBITHKANv0', {
      language: 'zh-TW',
      libraries: ['places']
    });
    this.google = await loader.load();
    this.googlePlaceService = new this.google.maps.places.AutocompleteService();
    this.geocoder = new this.google.maps.Geocoder();
  }
};
</script>

<style lang="scss" scoped>
.inputgrouplocation {
  &-field {
    display: flex;
    align-items: center;
    padding: 20px 80px;
    border-bottom: 1px solid $border-light;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background-color: #fafafa;
    }

    &-sub {
      display: flex;
      align-items: center;
      flex-grow: 1;
      &:first-child {
        margin-right: 80px;
      }
    }

    &-location {
      flex-grow: 1;
    }

    &-location-button-group {
      display: flex;
      margin-left: 10px;
      button {
        padding: 5px;
      }
      button + button {
        margin-left: 5px;
      }
    }
  }

  &-ride-coordinate {
    padding: 20px 80px 0;
    border-top: 1px solid #ededed;
    border-bottom: 1px solid #ededed;
    .table {
      color: #73879c;
    }
  }
}

.small-padding {
  .inputgrouplocation-field {
    padding: 10px 80px;
  }
  .inputgrouplocation-ride-coordinate {
    padding: 10px 80px;
  }
}
</style>
